import { render, staticRenderFns } from "./AddContact.vue?vue&type=template&id=46a20372&scoped=true"
import script from "./AddContact.vue?vue&type=script&lang=ts"
export * from "./AddContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a20372",
  null
  
)

export default component.exports